module.exports = __webpack_public_path__ + "static/img/06.e30f3a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/06.png
// module id = Xe6W
// module chunks = 0